export function obterListaTipoAtoConcessorioProcessoReferenciado() {
  return (
    [
      { label: '08 - Termo de Acordo', value: 'TERMODEACORDO' },
      { label: '10 - Regime Especial', value: 'REGIMEESPECIAL' },
      { label: '12 - Autorização Específica', value: 'AUTORIZACAOESPECIFICA' },
    ]
  );
}
